import { mq } from 'utilities/breakpoints'

const mediaBreakpoint = window.matchMedia(mq['MD_MIN'])

export default function ResizeRefresh() {
    window.addEventListener('resize', handleResize)

    function handleResize() {
        if (mediaBreakpoint.matches) {
            window.location.reload()
        }
    }
}
